module.exports = __webpack_public_path__ + "img/mark-A1.0f6d845.svg";